import {
  completeAgentGroupInteractiveLoginCapabilityRequest,
  confirmAgentGroupOAuthAuthorizationCapabilityRequest,
  createAgentConversation,
  deleteAgentConversation,
  decideAgentGroupComputerUseStartCapabilityRequest,
  decideAgentGroupHostAccessCapabilityRequest,
  ensureBridgeChatConversation,
  getAgentConversation,
  getChatBootstrap,
  listAgentActivities,
  listAgentGroupCapabilityRequests,
  listAgentConversationMessages,
  listAgentConversationPage,
  renameAgentConversation,
  sendAgentMessage,
  shareAgentGroupLocationCapabilityRequest,
  subscribeAgentActivities,
  subscribeAgentGroupCapabilityRequests,
  subscribeAgentConversationEvents,
} from '@/website/lib/chat-api';
import { shareChat } from '@/website/lib/shared-chat-api';
import type { ConversationCoreTransport } from './types';

export function createWebConversationTransport(): ConversationCoreTransport {
  return {
    getBootstrap: getChatBootstrap,
    ensureBridgeChatConversation,
    createConversation: createAgentConversation,
    listConversationPage: listAgentConversationPage,
    getConversation: getAgentConversation,
    listMessages: listAgentConversationMessages,
    sendMessage: sendAgentMessage,
    renameConversation: renameAgentConversation,
    deleteConversation: deleteAgentConversation,
    shareConversation: (conversationId, options) =>
      shareChat({
        conversationId,
        agentGroupId: options.agentGroupId,
        title: options.title,
      }),
    listCapabilityRequests: listAgentGroupCapabilityRequests,
    shareLocationCapabilityRequest: shareAgentGroupLocationCapabilityRequest,
    confirmOAuthAuthorizationCapabilityRequest:
      confirmAgentGroupOAuthAuthorizationCapabilityRequest,
    completeInteractiveLoginCapabilityRequest:
      completeAgentGroupInteractiveLoginCapabilityRequest,
    decideHostAccessCapabilityRequest:
      decideAgentGroupHostAccessCapabilityRequest,
    decideComputerUseStartCapabilityRequest:
      decideAgentGroupComputerUseStartCapabilityRequest,
    subscribeCapabilityRequests: subscribeAgentGroupCapabilityRequests,
    listActivities: listAgentActivities,
    subscribeConversationEvents: subscribeAgentConversationEvents,
    subscribeActivities: subscribeAgentActivities,
  };
}
